import { render } from "./RegisterSuccess.view.vue?vue&type=template&id=20a652b3"
import script from "./RegisterSuccess.view.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__